(function () {
  'use strict';

  if (!Modernizr.csstransforms || window.localStorage === 'undefined') {
    return;
  }

  var alwaysAnimate = false;

  function getAnimationStorageObject() {
    var lastIntroAnimation;

    if (typeof localStorage.lastIntroAnimation !== 'string') {
      lastIntroAnimation = {};
      try {
        localStorage.lastIntroAnimation = JSON.stringify(lastIntroAnimation);
      } catch (e) {
        // Writing to localStorage failed
        return false;
      }
    } else {
      try {
        lastIntroAnimation = JSON.parse(localStorage.lastIntroAnimation);
      } catch (e) {
        lastIntroAnimation = {};
      }
    }

    return lastIntroAnimation;
  }

  function shouldAnimate(id) {
    if (!id) {
      id = 'default';
    }

    var lastIntroAnimation = getAnimationStorageObject();
    if (lastIntroAnimation === false) {
      return false;
    }

    return window.scrollY < 380
      && alwaysAnimate || isNaN(lastIntroAnimation[id])
      || parseInt(lastIntroAnimation[id], 10) < new Date().getTime() - 60 * 60 * 1 * 1000;
  }

  function setAnimated(id) {
    if (!id) {
      id = 'default';
    }

    var lastIntroAnimation = getAnimationStorageObject();
    if (lastIntroAnimation === false) {
      return false;
    }

    lastIntroAnimation[id] = new Date().getTime();
    localStorage.lastIntroAnimation = JSON.stringify(lastIntroAnimation);
  }


  $(function () {
    // Front page animation
    var $frontpage = $('body.home'),
        $header,
        $descriptionBlock,
        $splashArea,
        $footer;

    if ($frontpage.length > 0 && shouldAnimate('frontpage')) {

      $('html').css('background-color', '#000');
      $('body').css('opacity', 0);

      var hasLoaded = false,
          loadAnimation;

      loadAnimation = function () {
        if (hasLoaded) {
          return;
        }

        hasLoaded = true;

        $('body').velocity({
          'opacity': 1
        }, {
          duration: 350
        });

        $header = $frontpage.find('[data-header]');
        $header.css('opacity', 0);
        $header.velocity({
          translateY: [0, '-100%'],
          opacity: [1, 0]
        }, {
          duration: 400,
          delay: 300,
          easing: 'easeOutCubic'
        });

        $descriptionBlock = $frontpage.find('.js-description-block');
        $descriptionBlock.css('opacity', 0);
        $descriptionBlock.velocity({
          opacity: [1, 0]
        }, {
          duration: 400,
          delay: 550,
          easing: 'easeOutCubic'
        });

        $splashArea = $frontpage.find('.splash-area > .inner-block .widget');
        $splashArea.css('opacity', 0);
        $splashArea.velocity({
          translateY: [0, '120%'],
          opacity: [1, 0]
        }, {
          duration: 400,
          delay: 300,
          easing: 'easeOutCubic'
        });

        $footer = $frontpage.find('.page-footer .section');
        $footer.css('opacity', 0);
        $footer.velocity({
          opacity: [1, 0]
        }, {
          duration: 400,
          delay: 500,
          easing: 'easeOutCubic'
        });

      };

      window.setTimeout(loadAnimation, 2000);
      $(window).on('load', loadAnimation);

      setAnimated('frontpage');
    }

    // Sub page intro animation
    var $pageContent = $('.page-content'),
        offsetTop;

    if ($pageContent.length > 0 && shouldAnimate('subpage')) {
      if (shouldAnimate('frontpage')) {
        $header = $('[data-header]');
        $header.css('opacity', 0);
        $header.velocity({
          translateY: [0, '-100%'],
          opacity: [1, 0]
        }, {
          duration: 400,
          delay: 300,
          easing: 'easeOutCubic'
        });
      }

      offsetTop = $pageContent.offset().top;

      $pageContent.css('opacity', 0);
      $pageContent.velocity({
        translateY: [0, window.innerHeight - offsetTop + window.scrollY],
        opacity: [1, 0]
      }, {
        duration: 500,
        delay: 200,
        easing: 'easeOutCubic'
      });

      setAnimated('subpage');
    }
  });

})();